import Vue from 'vue'
import App from './App.vue'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import { PC_PATH, MOBILE_PATH } from '@/utils/seo'
import { isMobileUA } from '@/utils/ua'
import '../src/assets/css/common.scss'

Vue.config.productionTip = false
Vue.use(ElementUI);

// ── 移动端跳转：浏览器端兜底 ──────────────────────────────────
// 正式生效的是**服务器端 302**（deploy/nginx-yuetaixing.conf 的 ★4 段 + map 块）：
// 百度《移动搜索》规范不建议用 JS 判断 UA 跳转（影响抓取判断与首屏速度），
// 所以主路径改到了 nginx。正常情况下手机访客在服务端就被送到手机页，下面的代码不会执行。
//
// 这里保留一份只作兜底：宝塔在改「网站设置 / 域名管理」时会按自己的模板
// 重新生成站点配置，万一 map 块被冲掉，手机访客至少不会看到 PC 版。
//
// 映射表直接复用 seo.js 的 PC_PATH / MOBILE_PATH —— 与 nginx map 里那张对照表同源，
// 避免第三个地方再抄一份、日后改路由时漏改。
const PC_TO_MOBILE = Object.keys(PC_PATH).reduce((m, name) => {
  m[PC_PATH[name]] = MOBILE_PATH[name]
  return m
}, {})
const MOBILE_TO_PC = Object.keys(PC_PATH).reduce((m, name) => {
  m[MOBILE_PATH[name]] = PC_PATH[name]
  return m
}, {})

router.beforeEach((to, from, next) => {
  // ⚠️ next() 只能调用一次。原实现里 PC 分支先 next('/') 又 next()，
  //    会触发 vue-router 的「next() called multiple times」告警，这里统一成单一出口。
  // ⚠️ 只在对照表里有对应项时才跳（与 nginx map 的规则一致）：
  //    表外的路径（静态资源、未知 URL）不跳，免得把 404 也跳成首页。
  const target = isMobileUA() ? PC_TO_MOBILE[to.path] : MOBILE_TO_PC[to.path]

  if (target && target !== to.path) {
    // 带上 query，详情页的 ?id= 不能丢
    next({ path: target, query: to.query })
    return
  }
  next()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
